// extracted by mini-css-extract-plugin
export default {"affiliation-field":"events-registration-client-js-form-fields-___AffiliationInput-module__affiliation-field___BY8Q9"};